import {useCallback} from "react";

import type {KeenSliderInstance} from "keen-slider";

export function useSliderNavigation(sliderInstance: KeenSliderInstance | null): {handlePrev: () => void; handleNext: () => void} {
    const handlePrev = useCallback((): void => {
        sliderInstance?.prev();
    }, [sliderInstance]);

    const handleNext = useCallback((): void => {
        sliderInstance?.next();
    }, [sliderInstance]);

    return {
        handlePrev,
        handleNext,
    };
}
